// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"642":"43de8819","836":"c25a6041","866":"ab9f6b25","895":"9a4aa9d4","949":"3fc34a0f","981":"1a21185b"}[chunkId] + ".chunk.css";
};